/**
 * Author:    Christopher Bailey
 * Created:   02.24.2022
 * Filename: /actions/index.js
 * Purpose: Will eventually combine all dispatch actions into a single location by importing them from different files and merging. Currently,
 * this is just the current actions for logging in and updating user tokens.
 * (c) Copyright by PDG+Creative.
 **/

import axios from 'axios';
import { userConstants } from'../actions/userTypes';
import { executeRecaptcha } from "react-google-recaptcha-v3"; // make sure you have this installed

export const postLoginUser = ({ credentials, recaptchaToken }) => async (dispatch) => {
  dispatch({ type: userConstants.LOGIN_START });

  try {
    // Only include the fields your backend expects
    const loginPayload = {
      email: credentials.email,
      password: credentials.password,
      ...(recaptchaToken ? { recaptchaToken } : {})
    };

    const res = await axios.post(`${process.env.REACT_APP_LOGIN}`, loginPayload);
    const { token, user } = res.data;

    localStorage.setItem('token', token);
    dispatch({ type: userConstants.LOGIN_SUCCESS, payload: { user, token } });

    try {
      await axios.put(process.env.REACT_APP_SET_STRIPE_CUSTOMER, { email: user.email });
    } catch (stripeErr) {
      console.error("Error setting Stripe customer:", stripeErr);
    }

    return res.data;
  } catch (err) {
    dispatch({ type: userConstants.LOGIN_FAIL, payload: err });
    throw new Error(err.response?.data?.message || "Incorrect Credentials. Please check your email and password.");
  }
};

export const setStripeCustomer = (stripeCustomer) => ({
    type: userConstants.SET_STRIPE_CUSTOMER,
    payload: stripeCustomer,
  });
  export const setStripeSubscription = (stripeSubscription) => ({
    type: userConstants.SET_STRIPE_SUBSCRIPTION,
    payload: stripeSubscription,
  });
export const postMasqueradeUser = (email) => async (dispatch) => {
    try {
      // Step 1: Clear current session (logout admin)
      localStorage.removeItem('token');
      dispatch({ type: userConstants.LOGOUT_USER });
      // Step 2: Call backend to masquerade as the selected user
      const res = await axios.post(`${process.env.REACT_APP_MASQUERADE}`, { email });
  
      const { token, user } = res.data;
  
      // Step 3: Store new token and update auth state
      localStorage.setItem('token', token);
  
      dispatch({
        type: userConstants.LOGIN_SUCCESS,
        payload: { user, token }
      });
  
    } catch (err) {
      console.error("Masquerade failed:", err);
      dispatch({ type: userConstants.LOGIN_FAIL, payload: err });
      alert("Masquerade failed.");
    }
  };
  
// Action to authenticate user with token
export const authenticateUserWithToken = (token) => async (dispatch) => {
    try {
      // Make a request to the server to verify the token
      const response = await axios.post(process.env.REACT_APP_AUTHENTICATION, {}, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`, // Include the token in the request header
        },
      });
  
      if (response.status === 200) {
        const { token: newToken, user } = response.data;
        // Store the new token in local storage
        localStorage.setItem('token', newToken);
  
        // Dispatch success action with the new token and user information
        dispatch({ 
          type: userConstants.STAY_LOGGED_IN, 
          payload: { user, token: newToken } // Include both user and token in the payload
        });
    
      } else {  
        // Token is invalid or expired, remove token from localStorage and log user out
        localStorage.removeItem('token');
        dispatch({ type: userConstants.LOGOUT_USER });
      }
    } catch (error) {
      console.error('Error authenticating user with token:', error);
      
      // Handle error, for example, show an error message to the user
      alert("Incorrect Credentials.");
      
      // Remove token from localStorage and log user out in case of error
      localStorage.removeItem('token');
      dispatch({ type: userConstants.LOGOUT_USER });
    }
  };



  export const postForgotPassword = ({ credentials, recaptchaToken }) => async dispatch => {
    dispatch({ type: userConstants.FORGOT_PASSWORD_START });
    try {
      const res = await axios.post(`${process.env.REACT_APP_FORGOT_PASS}`, { ...credentials, recaptchaToken });
      alert(res.data.message || "Recovery email sent.");
      dispatch({ type: userConstants.FORGOT_PASSWORD_SUCCESS, payload: res.data });
    } catch (err) {
      alert(err.response?.data?.message || "Failed to send password reset email.");
      dispatch({ type: userConstants.FORGOT_PASSWORD_FAILURE, payload: err });
      throw err;
    }
  };
  

export const postRegisterUser = (payload) => async (dispatch) => {
  dispatch({ type: userConstants.REGISTER_START });

  try {
    await axios.post(`${process.env.REACT_APP_REGISTER}`, {
      credentials: payload.credentials,
      recaptchaToken: payload.recaptchaToken, // send token to backend
    });

    dispatch({ type: userConstants.REGISTER_SUCCESS, payload });
    alert("Sign up successful.");
  } catch (err) {
    dispatch({ type: userConstants.REGISTER_FAIL, payload: err });

    alert("Email address successfully validated. Please login.");
    window.location.href = "/login";
  }
};
export const putUpdateUser = payload => dispatch => {
    dispatch({ type: userConstants.REGISTER_START })
    axios
    .put(`${process.env.REACT_APP_UP_USER}`, payload.credentials)
    .then(res => {
        dispatch({ type: userConstants.UPDATE_USER_SUCCESS, payload: payload });
    })
    .catch(err => dispatch({ type: userConstants.UPDATE_USER_FAIL, payload:err }));

};

export const updateToken = token => dispatch => {
    dispatch({ type: userConstants.UPDATE_TOKEN, payload: { token } });
};



export const logoutUser = payload => dispatch => {
    dispatch({ type: userConstants.LOGOUT_USER, payload: payload });
    payload.history.push('/login');
}


export const getActiveUsers = () => dispatch => {
    //console.log('dispatch?')
    dispatch({ type: userConstants.FETCH_ACTIVE_USERS })
        axios.get(`${process.env.REACT_APP_ACTIVE_USR}`)
            .then(res =>{
                //console.log(res.data, '<- Data in fetch dispatch')
                dispatch({
                    type: userConstants.FETCH_ACTIVE_SUCCESS,
                    payload: res.data
                })
            })
            .catch(err => {
               
                dispatch({
                    type: userConstants.FETCH_ACTIVE_FAIL,
                    error: err.response.data.message
                })
            })
}

export const getInactiveUsers = () => dispatch => {
    //console.log('dispatch?')
    dispatch({ type: userConstants.FETCH_INACTIVE_USERS })
        axios.get(`${process.env.REACT_APP_INACTIVE_USR}`)
            .then(res =>{
                //console.log(res.data)
                dispatch({
                    type: userConstants.FETCH_INACTIVE_SUCCESS,
                    payload: res.data
                })
            })
            .catch(err => {
               
                dispatch({
                    type: userConstants.FETCH_INACTIVE_FAIL,
                    error: err.response.data.message
                })
            })
}

/* 
export const activateUser = payload => dispatch => {
    dispatch({ type: userConstants.ACTIVATE_USER_START })
    axios
    .put(`${process.env.REACT_APP_ACTIVATE}`, payload.email)
    .then(res, err => {
        dispatch({ type: userConstants.ACTIVATE_USER_SUCCESS, payload: payload });
    })
    .catch(err => dispatch({ type: userConstants.ACTIVATE_USER_FAIL, payload:err }));

};

export const deactivateUser = payload => dispatch => {
    dispatch({ type: userConstants.DEACTIVATE_USER_START })
    axios
    .put(`${process.env.REACT_APP_DEACTIVATE}`, payload.email)
    .then(res => {
        dispatch({ type: userConstants.DEACTIVATE_USER_SUCCESS, payload: res.data });
    })
    .catch(err => 
        dispatch({
             type: userConstants.DEACTIVATE_USER_FAIL, 
             payload: err }));
   
}; */

export const putUpdatePassword = payload => dispatch => {
    dispatch({ type: userConstants.UPDATE_PASSWORD_START })
    axios
    .put(`${process.env.REACT_APP_UPDATE_PASS}`, payload.credentials)
    .then(res => {
        alert('Your password has been successfully updated.')
        dispatch({ type: userConstants.UPDATE_PASSWORD_SUCCESS, payload: payload })
    })
    .catch(err => {
        alert('Failed updating your password')        
        dispatch({ type: userConstants.UPDATE_PASSWORD_FAILURE, payload:err })
    });
};